/* uses vendor/mobile-menu-pusha.js */
function initHeaderSetup(hBlock){
  // Add on-scroll class
  watchHeaderScroll( 10, "has-scroll");

  if(getSize().w < 640){
    watchHeaderScroll( 10, "has-scroll-sm");
  }
}


/***************************************************
  Document init
***************************************************/
DOMReady(function() {
  var header = document.querySelector("#masthead")
  if(header)  initHeaderSetup(header);
});


// The ".has-scroll" class is triggered
// when the height of the header is scrolled

function watchHeaderScroll(scrollHeight, className){
  startMobileScrollWatch(scrollHeight, className);

  function startMobileScrollWatch(sH){
    window.addEventListener("scroll", headerMobileScrollWatch);
    headerMobileScrollWatch();

    function headerMobileScrollWatch(){
      var tHeight = sH;
      
      headerMobileScroll(tHeight, document.querySelector("body"), className);
    }
    function headerMobileScroll(tH, target, c){
      var vpScroll = window.pageYOffset || document.documentElement.scrollTop;

      if(vpScroll >= tH){
        target.classList.add(c);
      }
      else{
        target.classList.remove(c);
      }
    }
  }
}//watchHeaderScroll
